import React, { Component } from 'react';
// import logo from './../logo.svg';
// import './App.css';

class FormInput extends Component{
  constructor(){
    super();
    
    this.state = {
      focus: false,
      stillFocus: false,
      actFocus: false,
    }

    this.inputRef = React.createRef()
    
    this.checkValue = this.checkValue.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.outFocus = this.outFocus.bind(this);
  }

  componentDidMount(){
    this.checkValue();

    if(this.inputRef.current && this.props.autoFocus){
      this.inputRef.current.focus();

      this.onFocus();
    }
  }

  componentDidUpdate(prevProps, prevState){
    if(
      this.state.stillFocus !== prevState.stillFocus ||
      this.props.value !== prevProps.value
    ){
      this.checkValue();
    }
  }

  checkValue(){
    if(this.props.value === '' && !this.state.stillFocus){
      this.setState({ focus: false });
    }else{
      this.setState({ focus: true });
    }
  }

  onFocus(){
    this.setState({
      focus: true,
      actFocus: true,
      stillFocus: true
    });
  }

  outFocus(){
    this.setState({
      actFocus: false,
      stillFocus: false
    });

    this.checkValue();
  }

  // componentWillUnmount(){}

  render(){
    return(
      <>
        {/* <label className="label-input">{this.props.label} <span>*</span></label> */}
        <label className={`label-input ${this.state.focus ? 'focus' : ''} ${this.props.init && this.props.valid !== true ? 'error' : ''} ${this.props.disabled ? 'disabled' : ''}`}>{this.props.label} {this.props.required ? (<span>*</span>) : ''}</label>
        <input
          ref={this.inputRef}
          type={this.props.type}
          name={this.props.name}
          value={this.props.value}
          onChange={this.props.onChange}
          placeholder={this.props.label ? this.state.actFocus ? this.props.placeholder : undefined : this.props.placeholder}
          className={`${this.props.className ? this.props.className : ''} ${this.props.init && this.props.valid !== true ? 'error' : ''}`}
          onFocus={this.onFocus}
          onBlur={this.outFocus}
          disabled={this.props.disabled}
          autoFocus={this.props.autoFocus}
        />
        <div className={`error-msg ${this.props.init && this.props.valid !== true ? 'error-show' : ''}`}>{this.props.valid}</div>
      </>
    );
  }
}

export default FormInput;